import React from "react";
import { useGenericContext } from "@/context/generic";

const Navigation = (props) => {
    const context = useGenericContext();
    const { state, simpleDispatch } = context;

    const decrement = () => {
        if (state.funnel.submitting) return;
        if (state?.step?.current === 0) return;
        window.scrollTo({ top: 0 });

        simpleDispatch({
            step: {
                direction: -1,
                previous: state.step.current,
                current: state.step.current - 1,
            },
        })
    }

    const increment = () => {
        if (state.funnel.submitting) return;
        if (state?.step?.current === state?.step?.max) {
            state?.functions?.onSubmit?.();
            return;
        }

        window.scrollTo({ top: 0 });
        simpleDispatch({
            step: {
                direction: 1,
                previous: state.step.current,
                current: state.step.current + 1,
            },
        })
    }

    return (
        <div className="form__navigation">
            <button
                onClick={decrement}
                disabled={state?.step?.current == 0 || state?.step?.current > state?.step?.max}
            >
                Tilbake
            </button>
            <button
                onClick={increment}
                className={ state?.step?.current === state?.step?.max ? "submit" : "" }
                disabled={state?.step?.current > state?.step?.max}
            >
                { state?.step?.current >= state?.step?.max ? "Fullfør" : "Neste" }
            </button>
        </div>
    );
};

export default Navigation;
